import React from "react";

import * as Styled from "./styles";

import { ReactComponent as MenuIcon } from "shared/assets/svg/menu.svg";
import {
  Avatar,
  Badge,
  Menu,
  MenuItem,
  Typography,
  Box,
  Modal,
  CircularProgress,
  Button,
  Fab,
  FormControl,
  InputLabel,
  Select,
  SelectChangeEvent,
  /*Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,*/
} from "@mui/material";
import { MdDescription } from "react-icons/md";

import LinearProgress, {
  LinearProgressProps,
} from "@mui/material/LinearProgress";
import { menuPatient } from "shared/mock";
import { DEFAULT_AVATAR } from "shared/config/properties";
import { ROUTER } from "shared/constants/router";
import { CloseConsult } from "components/CloseConsult";
import { Documentation } from "components/Documentation";
import { ClinicalRecordUser, SimplifiedClinicalRecord } from "components/ClinicalRecord";
import { useMaintenance } from "shared/providers/Maintenance";
import { TreatmentPlan } from "components/TreatmentPlan";

import { FaPen, FaCircleInfo } from "react-icons/fa6";
import { postDiagnosis } from "requests/Diagnosis";
import { useAuth } from "shared/providers/auth";
import { EvolutionScreen } from "components/Evolution";
import { RecordPhysical } from "components/RecordPhysical";
import { ReferralStatusTracker } from "components/Referrals/StatusTracker";
import { NotesUser } from "components/Notes";
import { ReturnButton } from "components/ReturnButton";
import { WaitingPatients } from "components/WaitingPatients";
import { getAttendedConsultations } from "requests/Patient";
import { IAttendedConsultationsData } from "shared/types/Patient";

interface IProps {
  title: { title: string; max: number; step: number; firstPass: number }[];
  children?: any;
}

const HeadConsult: React.FC<IProps> = ({ title, children }) => {
  const { user, scheduleData } = useAuth();
  const {
    patientObj,
    step,
    showOtherProcedureScreen,
    proceduresLastAttendance,
    showQuestionsReturn,
  } = useMaintenance();

  const currentScheduleId = React.useMemo(() => {
    try {
      const raw = localStorage.getItem("personAttendance");
      if (raw) return JSON.parse(raw)?.id ?? null;
    } catch {}
    return null;
  }, []);

  const waitingCount = React.useMemo(() => {
    let count = 0;
    scheduleData.forEach((slot) => {
      slot.data?.forEach((item) => {
        if (
          (item.st_schedule === "C" || item.st_schedule === "T") &&
          item.inService !== 1 &&
          item.id !== currentScheduleId
        ) count++;
      });
    });
    return count;
  }, [scheduleData, currentScheduleId]);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const [openModal, setOpenModal] = React.useState<boolean>(false);

  const [typeBraceId, setTypeBraceId] = React.useState<number>(0);
  const [loading, setLoading] = React.useState<boolean>(false);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [openClose, setOpenClose] = React.useState<boolean>(false);

  const [openCloseDocumentation, setOpenCloseDocumentation] =
    React.useState<boolean>(false);

  const [openCloseClinicalRecord, setOpenCloseClinicalRecord] =
    React.useState<boolean>(false);

  const [openCloseTreatment, setOpenCloseTreatment] =
    React.useState<boolean>(false);

  const [openEvolution, setOpenEvolution] = React.useState<boolean>(false);

  const [openPhysical, setOpenPhysical] = React.useState<boolean>(false);

  const [openReferrals, setOpenReferrals] = React.useState<boolean>(false);

  const [openNotes, setOpenNotes] = React.useState<boolean>(false);

  const [openSimplifiedRecord, setOpenSimplifiedRecord] = React.useState<boolean>(false);
  const [openWaitingPatients, setOpenWaitingPatients] = React.useState<boolean>(false);

  const [openPatientInfo, setOpenPatientInfo] = React.useState<boolean>(false);

  const [pos, setPos] = React.useState<boolean>(false);
  const [message, setMessage] = React.useState<string>("");

  const [attendedConsultations, setAttendedConsultations] =
    React.useState<IAttendedConsultationsData | null>(null);

  //const [dialogInfo, setDialogInfo] = React.useState<boolean>(false);

  const closeModal = () => {
    setOpenModal(false);
    setMessage("");
    setPos(false);
    window.location.reload();
  };

  const handleChange = (event: SelectChangeEvent) => {
    setTypeBraceId(Number(event.target.value));
  };

  const registerDiagnosis = async () => {
    setLoading(true);

    const patientData = localStorage.getItem("personAttendance");

    if (patientData) {
      const patient = JSON.parse(patientData);
      patient.type = typeBraceId;
      localStorage.setItem("personAttendance", JSON.stringify(patient));
    }

    try {
      const { data: dataDiagnosis, status } = await postDiagnosis({
        id: user.data.id,
        idPac: patientObj.pac_id,
        type: typeBraceId,
      });

      if ([200, 201].includes(status)) {
        setMessage(dataDiagnosis.message);
        setPos(true);
        setLoading(false);
      } else {
        setMessage(dataDiagnosis.message);
        setPos(true);
        setLoading(false);
      }
    } catch (e) {
      setLoading(false);
    }
  };

  function LinearProgressWithLabel(
    props: LinearProgressProps & { value: number }
  ) {
    const row = title.find((item) => item.step === step);

    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column-reverse",
          gap: "10px",
        }}
      >
        <Box sx={{ width: "100%" }}>
          <LinearProgress variant="determinate" {...props} />
        </Box>
        <Box>
          <Typography
            variant="body2"
            color="#007DED"
            sx={{ fontWeight: "500", fontSize: "18px" }}
          >
            {step === 1 && showOtherProcedureScreen
              ? `${String(
                  row?.firstPass &&
                    row.firstPass +
                      (showOtherProcedureScreen ||
                      proceduresLastAttendance.length > 0
                        ? 1
                        : 0)
                )} de ${String(
                  row?.max &&
                    row.max +
                      (showOtherProcedureScreen ||
                      proceduresLastAttendance.length > 0
                        ? 1
                        : 0)
                )} - Outros Procedimentos`
              : step === 1 &&
                proceduresLastAttendance.length > 0 &&
                showQuestionsReturn
              ? `1 de ${String(
                  row?.max &&
                    row.max +
                      (showOtherProcedureScreen ||
                      proceduresLastAttendance.length > 0
                        ? 1
                        : 0)
                )} - Outros Procedimentos - Atendimento anterior`
              : row?.title
                  .replace("[end]", String(row?.max))
                  .replace("[start]", String(row?.firstPass))}
          </Typography>
        </Box>
      </Box>
    );
  }

  function LinearWithValueLabel() {
    return (
      <Box sx={{ width: "100%" }}>
        <LinearProgressWithLabel
          value={
            step === 1
              ? 25
              : step === 2
              ? 50
              : step === 3
              ? 75
              : step === 4
              ? 100
              : 0
          }
        />
      </Box>
    );
  }

  const handleCamera = () => {
    //@ts-ignore
    if (window && window.ReactNativeWebView) {
      //call rn to play audio
      //@ts-ignore
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          action: "openCamera",
          value: "",
        })
      );
    }
  };

  React.useEffect(() => {
    setTypeBraceId(patientObj.type);
  }, [patientObj]);

  React.useEffect(() => {
    const fetchAttendedConsultations = async () => {
      try {
        const { data, status } = await getAttendedConsultations(
          user.data.id,
          patientObj.pac_id
        );
        if ([200, 201].includes(status) && data.success) {
          setAttendedConsultations(data.data);
        }
      } catch (error) {
        console.error("Erro ao buscar consultas atendidas:", error);
      }
    };

    if (patientObj && patientObj.pac_id) {
      fetchAttendedConsultations();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patientObj?.pac_id, user.data.id]);

  return (
    <>
      <Styled.Box>
        <Styled.FakeBox></Styled.FakeBox>
        <Styled.Info>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <Avatar
              src={
                patientObj.pac_avatar ? patientObj.pac_avatar : DEFAULT_AVATAR
              }
              sx={{ width: "55px", height: "55px" }}
              alt={patientObj.pac_name}
            />
            <Typography sx={{ color: "#919296", fontWeight: "500" }}>
              ID {patientObj.pac_id_fant}
            </Typography>
            <Typography
              sx={{ color: "#343536", fontWeight: "bold", fontSize: "20px" }}
            >
              {patientObj.pac_name && patientObj.pac_name}
            </Typography>
          </Box>

          <LinearWithValueLabel />
        </Styled.Info>
        <Styled.Menu>
          <button
            onClick={handleClick}
            style={{
              backgroundColor: "transparent",
              border: "none",
            }}
          >
            <Badge badgeContent={waitingCount} color="error" max={99}>
              <MenuIcon />
            </Badge>
          </button>
        </Styled.Menu>
      </Styled.Box>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem>
          <Styled.NoLink onClick={() => setOpenPatientInfo(true)}>
            <FaCircleInfo color="#053779" /> Informações do Paciente
          </Styled.NoLink>
        </MenuItem>
        {menuPatient.map((item, index) => (
          <div key={`idx${index}`}>
            {item.href === "/PHYSICAL" ? (
              <MenuItem key={index}>
                <Styled.NoLink onClick={() => setOpenPhysical(true)}>
                  {<item.icon color="#053779" />} {item.text}
                </Styled.NoLink>
              </MenuItem>
            ) : item.href === "/EVOLUTION" ? (
              <MenuItem key={index}>
                <Styled.NoLink onClick={() => setOpenEvolution(true)}>
                  {<item.icon color="#053779" />} {item.text}
                </Styled.NoLink>
              </MenuItem>
            ) : item.text === "Tirar Foto" ? (
              <MenuItem key={index} onClick={handleCamera}>
                <Styled.NoLink>
                  {<item.icon color="#053779" />} {item.text}
                </Styled.NoLink>
              </MenuItem>
            ) : item.href === "/TRATAMENTO" ? (
              <MenuItem key={index}>
                <Styled.NoLink onClick={() => setOpenCloseTreatment(true)}>
                  {<item.icon />} {item.text}
                </Styled.NoLink>
              </MenuItem>
            ) : item.href === "/DOC" ? (
              <MenuItem key={index}>
                <Styled.NoLink onClick={() => setOpenCloseDocumentation(true)}>
                  {<item.icon />} {item.text}
                </Styled.NoLink>
              </MenuItem>
            ) : item.href === "/FICHA" ? (
              <MenuItem key={index}>
                <Styled.NoLink onClick={() => setOpenCloseClinicalRecord(true)}>
                  {<item.icon />} {item.text}
                </Styled.NoLink>
              </MenuItem>
            ) : item.href === "/FICHA_RESUMIDA" ? (
              <MenuItem key={index}>
                <Styled.NoLink onClick={() => setOpenSimplifiedRecord(true)}>
                  {<item.icon />} {item.text}
                </Styled.NoLink>
              </MenuItem>
            ) : item.href === "/NOTES" ? (
              <MenuItem key={index}>
                <Styled.NoLink onClick={() => setOpenNotes(true)}>
                  {<item.icon />} {item.text}
                </Styled.NoLink>
              </MenuItem>
            ) : item.href === "/ENCAMINHAMENTOS" ? (
              <MenuItem key={index}>
                <Styled.NoLink onClick={() => setOpenReferrals(true)}>
                  {<item.icon />} {item.text}
                </Styled.NoLink>
              </MenuItem>
            ) : item.href === "/WAITING" ? (
              <MenuItem key={index}>
                <Styled.NoLink onClick={() => { setOpenWaitingPatients(true); handleClose(); }}>
                  {<item.icon color="#053779" />} {item.text}
                </Styled.NoLink>
              </MenuItem>
            ) : item.href !== ROUTER.CLOSE_CONSULT ? (
              <MenuItem key={index}>
                <Styled.Link href={item.href}>
                  {<item.icon />} {item.text}
                </Styled.Link>
              </MenuItem>
            ) : (
              <MenuItem key={index}>
                <Styled.NoLink onClick={() => setOpenClose(true)}>
                  {<item.icon />} {item.text}
                </Styled.NoLink>
              </MenuItem>
            )}
          </div>
        ))}

        {/* 
        <Dialog open={dialogInfo} onClose={() => setDialogInfo(false)}>
          <DialogTitle>Informações</DialogTitle>
          <DialogContent>
            <Box
              sx={{ display: "flex", flexDirection: "column", height: "100%" }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "row",
                  gap: "10px",
                }}
              >
                <Typography variant="body1">Dentista Responsável:</Typography>
                <Typography variant="body2" fontWeight="bold">
                  Teste
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "row",
                  gap: "10px",
                }}
              >
                <Typography variant="body1">Tipo de aparelho:</Typography>
                <Typography variant="body2" fontWeight="bold">
                  Fixo
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "row",
                  gap: "10px",
                }}
              >
                <Typography variant="body1">Benefícios:</Typography>
                <Typography variant="body2" fontWeight="bold">
                  Limpeza
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "row",
                  gap: "10px",
                }}
              >
                <Typography variant="body1">
                  Data de vencimento do orçamento:
                </Typography>
                <Typography variant="body2" fontWeight="bold">
                  Dia 10
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "row",
                  gap: "10px",
                }}
              >
                <Typography variant="body2" fontWeight="bold">
                  Controle de contenção 1/8
                </Typography>
              </Box>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button variant="contained" onClick={() => setDialogInfo(false)}>
              Fechar
            </Button>
          </DialogActions>
        </Dialog>
       */}

        <Modal open={openClose} onClose={() => setOpenClose(false)}>
          <Box sx={{ backgroundColor: "white", height: "100%", width: "100%" }}>
            {openClose && (
              <CloseConsult
                close={() => setOpenClose(false)}
                idSchedule={patientObj.id}
              />
            )}
          </Box>
        </Modal>

        <Modal
          open={openCloseClinicalRecord}
          onClose={() => setOpenCloseClinicalRecord(false)}
        >
          <Box sx={{ backgroundColor: "white", height: "100%", width: "100%" }}>
            {openCloseClinicalRecord && (
              <ClinicalRecordUser
                onClick={() => setOpenCloseClinicalRecord(false)}
                idPacientParam={patientObj.pac_id}
              />
            )}
          </Box>
        </Modal>

        <Modal
          open={openCloseTreatment}
          onClose={() => setOpenCloseTreatment(false)}
        >
          <Box sx={{ backgroundColor: "white", height: "100%", width: "100%" }}>
            {openCloseTreatment && (
              <TreatmentPlan
                onClick={() => setOpenCloseTreatment(false)}
                idPacientParam={patientObj.pac_id}
              />
            )}
          </Box>
        </Modal>

        <Modal open={openEvolution} onClose={() => setOpenEvolution(false)}>
          <Box sx={{ backgroundColor: "white", height: "100%", width: "100%" }}>
            {openEvolution && (
              <EvolutionScreen
                onClick={() => setOpenEvolution(false)}
                idPacientParam={patientObj.pac_id}
              />
            )}
          </Box>
        </Modal>

        <Modal open={openPhysical} onClose={() => setOpenPhysical(false)}>
          <Box sx={{ backgroundColor: "white", height: "100%", width: "100%" }}>
            {openPhysical && (
              <RecordPhysical
                onClick={() => setOpenPhysical(false)}
                idPacientParam={patientObj.pac_id}
              />
            )}
          </Box>
        </Modal>

        <Modal open={openReferrals} onClose={() => setOpenReferrals(false)}>
          <Box sx={{ backgroundColor: "white", height: "100%", width: "100%", overflow: "auto" }}>
            {openReferrals && (
              <Box sx={{ padding: "16px" }}>
                <ReturnButton
                  title="Encaminhamentos e Solicitações"
                  onClick={() => setOpenReferrals(false)}
                />
                <ReferralStatusTracker pacienteId={patientObj.pac_id} />
              </Box>
            )}
          </Box>
        </Modal>

        <Modal open={openNotes} onClose={() => setOpenNotes(false)}>
          <Box sx={{ backgroundColor: "white", height: "100%", width: "100%", overflow: "auto" }}>
            {openNotes && (
              <Box sx={{ padding: "16px" }}>
                <ReturnButton
                  title="Observações"
                  onClick={() => setOpenNotes(false)}
                />
                <NotesUser idPacientParam={patientObj.pac_id} />
              </Box>
            )}
          </Box>
        </Modal>

        <Modal open={openSimplifiedRecord} onClose={() => setOpenSimplifiedRecord(false)}>
          <Box sx={{ backgroundColor: "white", height: "100%", width: "100%", overflow: "auto" }}>
            {openSimplifiedRecord && (
              <Box sx={{ padding: "16px" }}>
                <ReturnButton
                  title="Ficha Resumida"
                  onClick={() => setOpenSimplifiedRecord(false)}
                />
                <SimplifiedClinicalRecord idPacientParam={patientObj.pac_id} />
              </Box>
            )}
          </Box>
        </Modal>

        <Modal open={openPatientInfo} onClose={() => setOpenPatientInfo(false)}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "90%",
              maxWidth: "500px",
              bgcolor: "background.paper",
              borderRadius: "16px",
              boxShadow: 24,
              p: 0,
              overflow: "hidden",
            }}
          >
            {/* Header */}
            <Box
              sx={{
                background: "linear-gradient(135deg, #042b7e 0%, #007DED 100%)",
                padding: "24px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "12px",
              }}
            >
              <Avatar
                src={patientObj.pac_avatar ? patientObj.pac_avatar : DEFAULT_AVATAR}
                sx={{ width: "80px", height: "80px", border: "3px solid white" }}
                alt={patientObj.pac_name}
              />
              <Typography
                sx={{
                  color: "white",
                  fontWeight: "bold",
                  fontSize: "20px",
                  textAlign: "center",
                }}
              >
                {patientObj.pac_name}
              </Typography>
              <Typography
                sx={{
                  color: "rgba(255,255,255,0.8)",
                  fontSize: "14px",
                }}
              >
                ID {patientObj.pac_id_fant}
              </Typography>
            </Box>

            {/* Content */}
            <Box sx={{ padding: "24px", display: "flex", flexDirection: "column", gap: "16px" }}>
              {patientObj.Name_detRel && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "12px 16px",
                    backgroundColor: "#f5f7fa",
                    borderRadius: "10px",
                  }}
                >
                  <Typography sx={{ color: "#666", fontSize: "14px" }}>
                    Dentista Responsável
                  </Typography>
                  <Typography sx={{ color: "#042b7e", fontWeight: "600", fontSize: "14px" }}>
                    {patientObj.Name_detRel}
                  </Typography>
                </Box>
              )}

              {patientObj.aparelhos && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "12px 16px",
                    backgroundColor: "#f5f7fa",
                    borderRadius: "10px",
                  }}
                >
                  <Typography sx={{ color: "#666", fontSize: "14px" }}>
                    Plano Contratado
                  </Typography>
                  <Typography sx={{ color: "#042b7e", fontWeight: "600", fontSize: "14px" }}>
                    {patientObj.aparelhos}
                  </Typography>
                </Box>
              )}

              {patientObj.beneficios && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "12px 16px",
                    backgroundColor: "#f5f7fa",
                    borderRadius: "10px",
                  }}
                >
                  <Typography sx={{ color: "#666", fontSize: "14px" }}>
                    Benefícios
                  </Typography>
                  <Typography sx={{ color: "#042b7e", fontWeight: "600", fontSize: "14px" }}>
                    {patientObj.beneficios}
                  </Typography>
                </Box>
              )}

              {patientObj.dia_vcto && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "12px 16px",
                    backgroundColor: "#f5f7fa",
                    borderRadius: "10px",
                  }}
                >
                  <Typography sx={{ color: "#666", fontSize: "14px" }}>
                    Data de Vencimento
                  </Typography>
                  <Typography sx={{ color: "#042b7e", fontWeight: "600", fontSize: "14px" }}>
                    Dia {patientObj.dia_vcto}
                  </Typography>
                </Box>
              )}

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "12px 16px",
                  backgroundColor: "#f5f7fa",
                  borderRadius: "10px",
                  cursor: "pointer",
                  "&:hover": {
                    backgroundColor: "#e8f4fd",
                  },
                }}
                onClick={() => {
                  setOpenPatientInfo(false);
                  setOpenModal(true);
                }}
              >
                <Typography sx={{ color: "#666", fontSize: "14px" }}>
                  Tipo de Aparelho
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <Typography sx={{ color: "#042b7e", fontWeight: "600", fontSize: "14px" }}>
                    {patientObj.type === 1
                      ? "Fixo"
                      : patientObj.type === 2
                      ? "Móvel"
                      : patientObj.type === 3
                      ? "Invisível"
                      : "Não definido"}
                  </Typography>
                  <FaPen color="#007DED" size={12} />
                </Box>
              </Box>

              {patientObj.proc_name === "Controle de Contenção" && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "12px 16px",
                    backgroundColor: "#e3f2fd",
                    borderRadius: "10px",
                  }}
                >
                  <Typography sx={{ color: "#666", fontSize: "14px" }}>
                    Controle de Contenção
                  </Typography>
                  <Typography sx={{ color: "#1565c0", fontWeight: "600", fontSize: "14px" }}>
                    {patientObj.qtd_contencao}/8
                  </Typography>
                </Box>
              )}

              {attendedConsultations && attendedConsultations.total_attended > 0 && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "12px 16px",
                    backgroundColor: "#e8f5e9",
                    borderRadius: "10px",
                  }}
                >
                  <Typography sx={{ color: "#666", fontSize: "14px" }}>
                    Consultas Atendidas
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <Typography
                      sx={{
                        color: "#2e7d32",
                        fontWeight: "700",
                        fontSize: "16px",
                        backgroundColor: "#c8e6c9",
                        padding: "4px 12px",
                        borderRadius: "20px",
                      }}
                    >
                      {attendedConsultations.total_attended}
                    </Typography>
                    {attendedConsultations.treatment_start_formatted && (
                      <Typography sx={{ color: "#666", fontSize: "12px" }}>
                        desde {attendedConsultations.treatment_start_formatted}
                      </Typography>
                    )}
                  </Box>
                </Box>
              )}
            </Box>

            {/* Footer */}
            <Box sx={{ padding: "16px 24px", borderTop: "1px solid #eee" }}>
              <Button
                fullWidth
                variant="contained"
                onClick={() => setOpenPatientInfo(false)}
                sx={{
                  backgroundColor: "#042b7e",
                  borderRadius: "10px",
                  padding: "12px",
                  textTransform: "none",
                  fontWeight: "600",
                  "&:hover": {
                    backgroundColor: "#031d54",
                  },
                }}
              >
                Fechar
              </Button>
            </Box>
          </Box>
        </Modal>
      </Menu>

      <WaitingPatients open={openWaitingPatients} onClose={() => setOpenWaitingPatients(false)} />

      <Modal
        open={openCloseDocumentation}
        onClose={() => setOpenCloseDocumentation(false)}
      >
        <Box sx={{ backgroundColor: "white", height: "100%", width: "100%" }}>
          {openCloseDocumentation && (
            <Documentation
              onClick={() => setOpenCloseDocumentation(false)}
              idPacientParam={patientObj.pac_id}
            />
          )}
        </Box>
      </Modal>

      {children}

      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Styled.BoxModal>
          {loading ? (
            <CircularProgress />
          ) : (
            <>
              {pos ? (
                <>
                  <Typography>{message}</Typography>
                  <Button onClick={closeModal}>Fechar</Button>
                </>
              ) : (
                <>
                  <Typography>
                    Escolha um tipo de aparelho para continuar
                  </Typography>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Tipo de aparelho
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={String(typeBraceId)}
                      label="Tipo de aparelho"
                      onChange={handleChange}
                    >
                      <MenuItem value={1}>Aparelho Fixo</MenuItem>
                      <MenuItem value={2}>Aparelho Móvel</MenuItem>
                      <MenuItem value={3}>Aparelho Invisível</MenuItem>
                    </Select>
                  </FormControl>
                  <Styled.BoxButtons>
                    <Button
                      variant="outlined"
                      onClick={() => setOpenModal(false)}
                    >
                      Cancelar
                    </Button>
                    <Button onClick={registerDiagnosis}>Enviar</Button>
                  </Styled.BoxButtons>
                </>
              )}
            </>
          )}
        </Styled.BoxModal>
      </Modal>

      <Fab
        color="primary"
        size="medium"
        aria-label="Documentação do Paciente"
        onClick={() => setOpenCloseDocumentation(true)}
        sx={{
          position: "fixed",
          bottom: 24,
          right: 24,
          zIndex: 1200,
          backgroundColor: "#053779",
          "&:hover": { backgroundColor: "#042a5c" },
        }}
      >
        <MdDescription size={22} color="#fff" />
      </Fab>
    </>
  );
};

export { HeadConsult };
